"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerEntryType = void 0;
/**
 * @deprecated All Ledger types have been merged into JournalEntry.
 * Import from './JournalEntry' instead.
 */
var JournalEntry_1 = require("./JournalEntry");
Object.defineProperty(exports, "LedgerEntryType", { enumerable: true, get: function () { return JournalEntry_1.JournalEntryType; } });
